import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" action: the intent the UI dispatches for the saga to act on. Kept
 * out of the slice's reducers: it triggers a side effect, not a state
 * transition (the saga owns the resulting `save*` transitions).
 */

/** Create the fundraising from the current draft (dispatched on Save). */
export const submitRequested = createAction('addFundraising/submitRequested');
